module.exports = __webpack_public_path__ + "img/main_bg.fb83c246.jpg";